module.exports = __webpack_public_path__ + "img/login.13df8b7c.png";